export default "__VITE_ASSET__BVPFcoT3__"